<script>
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

export default {
  data () {
    return {
      dados: null,
      fieldValue: ''
    }
  },
  methods: {
    clear: function () {
      this.model = ''
    }
  },
  components: { Datetime },
  computed: {
    model: {
      get () {
        return this.fieldValue
      },
      set (newValue) {
        this.$emit('change', newValue)
        this.fieldValue = newValue
      }
    }
  },
  props: {
    formato: {
      type: Object,
      default: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'},
      required: false
    },
    tipo: {
      type: String,
      default: 'datetime',
      required: false
    },
    classe: {
      type: String,
      default: 'input-data',
      required: false
    },
    value: {
      type: String,
      default: '',
      required: false
    }
  },
  watch: {
    value: function () {
      if (this.value === '' || this.value === null) {
        this.clear()
      } else {
        this.model = this.value
      }
    }
  }
}
</script>
<template>
  <div>
    <datetime
      v-model="model"
      :format="formato"
      :type="tipo"
      auto
      :class="classe"
      zone='utc+3'>
    </datetime>
    <span v-if="model !== ''" @click="clear"><i class="fa fa-times"></i></span>
  </div>
</template>

<style scoped>
  .input-data, span {
    float: left;
  }
  .input-data .input-data {
    width: 80%;
  }
  span {
    width: auto;
    margin-left: 3px;
    margin-right: 8px;
    height: 29px;
    line-height: 29px;
    cursor: pointer;
  }
  .input-data span {
    height: 35px;
    line-height: 35px;
  }
  span i{
    font-size: 16px
  }
  .input-data span i {
    font-size: 18px
  }
</style>



// WEBPACK FOOTER //
// date-time.vue?6a391390